/*
 * Copyright (c) 2025. Bolmate B.V.
 */
import './style/notificationFeedback.scss';

import {ChangeFunction, CloseButton, Loader, WithBackground} from '@dvrd/dvr-controls';
import React, {MouseEventHandler} from 'react';
import {BolmateButton, BolmateInput} from "../../controls";

interface Props {
    onClose: MouseEventHandler;
    onChangeFeedback: ChangeFunction<string>;
    onSubmit: MouseEventHandler;
    feedback: string;
    loading: boolean;
    open: boolean;
}

export default function NotificationFeedback(props: Props) {
    const {onClose, onChangeFeedback, onSubmit, feedback, loading, open} = props;

    function renderBody() {
        return (
            <div className='body-container'>
                <Loader active={loading}/>
                <BolmateInput onChange={onChangeFeedback} value={feedback} inputProps={{rows: 5}}
                              placeholder='Waarvoor zou je ook notificaties willen ontvangen?' area/>
            </div>
        )
    }

    return (
        <WithBackground active={open} onClose={onClose}>
            <div className='default-popup notification-feedback'>
                <div className='header-container'>
                    <label className='header-title'>Tip ons waarvoor je nog meer een notificatie voor wilt
                        ontvangen</label>
                    <CloseButton onClick={onClose}/>
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <BolmateButton onClick={onClose} label='Annuleren' disabled={loading} secondary/>
                    <BolmateButton onClick={onSubmit} label='Feedback verzenden'
                                   disabled={loading || !feedback.length}/>
                </div>
            </div>
        </WithBackground>
    )
}